export function formatHTML(s, {extra}={}) {
  if (!s) {
    return ''
  }
  s = s.replace(/</g, '&lt;').replace('/>/g', '&gt;').replace(/"/g, '&quot;')
  s = s.replace(/!!!([^]+?)!!!/g, '<h4 class="content-heading">$1</h4>')
  s = s.replace(/!!([^]+?)!!/g, '<strong>$1</strong>')
  s = s.replace(/%%([^]+?)%%/g, '<em>$1</em>')
  s = s.replace(/__([^]+?)__/g, '<span class="underline">$1</span>')
  s = s.replace(/##([^]+?)##/g, '<span class="content-quote">$1</span>')
  s = s.replace(/\(\(([^]+?)\)\)/g, '<span class="small">$1</span>')
  s = s.replace(/\[([^\]]+?)\]\[(\d+?)\]/g, '<span class="link"><sup data-footnote="$1">$2</sup></span>')
  s = s.replace(/\[([^\]]+?)\]\[@(.+?)\]/g, (m, p1, p2) => `<a href="${formatHTML.parseURL(p2)}">${p1}</a>`)
  s = s.replace(/\[([^\]]+?)\]\[(.+?)\]/g, '<a href="$2">$1</a>')
  s = s.replace(/\{\{\s*([^]*?)\s*\}\}/g, (m, p1) => {
    p1 = p1.trim()
    if (p1.startsWith('-')) {
      return '<ul>' + p1.replace(/(?:^|\n)- ([^]*?)(?=\n-|$)/g, '<li>$1</li>', p1) + '</ul>'
    } else {
      return '<ol>' + p1.replace(/(?:^|\n)\d+\. ([^]*?)(?=\n\d+\.|$)/g, '<li>$1</li>', p1) + '</ol>'
    }
  })
  s = s.trim()
  s = s.replace(/\n\r?(\n\r?)+/g, '</p><p>')
  s = s.replace(/\n\r?/g, '<br/>')
  return '<p>' + (extra || '') + s + '</p>'
}

export function formatText(s) {
  if (!s) {
    return ''
  }
  s = s.replace(/!!!([^]+?)!!!/g, '$1. ')
  s = s.replace(/!!([^]+?)!!/g, '$1')
  s = s.replace(/%%([^]+?)%%/g, '$1')
  s = s.replace(/__([^]+?)__/g, '$1')
  s = s.replace(/##([^]+?)##/g, '$1')
  s = s.replace(/\[(.+?)\]\[\d+?\]/g, ' ($1) ')
  s = s.replace(/\[(.+?)\]\[.+?\]/g, '$1')
  s = s.replace(/\{\{\s*([^]*?)\s*\}\}/g, '$1')
  s = s.replace(/\s+?(\n\r?)+/g, ' ')
  return s
}



// WEBPACK FOOTER //
// ./src/components/format.js